import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, BottomSheet, MenuItem, Row, Typography, useOverlayContext } from 'seagull';
import { ChevronRight } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { BiometricLoginSheet } from './BiometricLoginSheet';
import { useBiometricLoginToggle } from './useBiometricLoginToggle';
export const GetBiometricLoginMenuItemTID = (parentTestId)=>getTestIds(parentTestId);
export const BiometricLoginMenuItem = (param)=>{
    let { testId = '' } = param;
    const { available, setupNeeded, method } = useBiometricLoginToggle();
    const { showModal } = useOverlayContext();
    const { t: profileTexts } = useLocaleKeys('pages.profile');
    const { BiometricLoginMenuItemTestIds } = useMemo(()=>GetBiometricLoginMenuItemTID(testId), [
        testId
    ]);
    if (!available && !setupNeeded) {
        return null;
    }
    const menuItemTestId = setupNeeded ? BiometricLoginMenuItemTestIds.SetupCta() : BiometricLoginMenuItemTestIds.Root();
    const label = setupNeeded ? profileTexts.biometricSecurity.setupCtaLabel({
        method
    }) : profileTexts.biometricSecurity.toggleLabel({
        method
    });
    return /*#__PURE__*/ _jsx(MenuItem, {
        skin: "secondary",
        testId: menuItemTestId,
        onClick: ()=>showModal({
                biName: 'biometric_login',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(BottomSheet, {
                        open: true,
                        joinOpenSheetStack: true,
                        onClose: dismissModal,
                        children: /*#__PURE__*/ _jsx(BiometricLoginSheet, {})
                    });
                }
            }),
        children: /*#__PURE__*/ _jsxs(Row, {
            width: "100%",
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: label
                }),
                /*#__PURE__*/ _jsx(Box, {
                    testId: BiometricLoginMenuItemTestIds.Chevron(),
                    children: /*#__PURE__*/ _jsx(ChevronRight, {})
                })
            ]
        })
    });
};
